import styled from 'styled-components';

export const Wrapper = styled.div`
  margin: 0 auto;
`;

export const ActivitiesContainer = styled.div`
  width: 672px;
  border-radius: 4px;
  margin: 16px 0 16px 0;
`;

export const StatsContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin: 0 0 16px 0;
`;

export const LoaderWrapper = styled.div`
  height: 90px;
  width: 90px;
  border-radius: 50%;
  border: 4px solid #fff;
  margin-bottom: 8px;
`;
